type SiteStartSectionSort = "normal" | "small";

interface ISiteStartSectionItem
    extends ISiteActionButton {
}

interface ISiteStartSection {
    title: string;
    items: ISiteStartSectionItem[];
    sort: SiteStartSectionSort;
}

class SiteStart
    extends QueryElement<HTMLElement> {

    constructor(element: HTMLElement, site: Site, sections: ISiteStartSection[]) {
        super(element)

        let color = 0;
        let list = QueryElement.QueryElement("UL");

        for (let section of sections) {
            let container = QueryElement.QueryElement("UL");
            let count = 0;

            for (let item of section.items) {

                // If action isn't defined, continue
                if (!item.action)
                    continue;

                count++;
                let wrapper = new SiteCardContainerWrapper(
                    new SiteContainerStartWrapper(site.Config)
                );

                QueryElement.QueryElement("LI")
                    .append(new SiteActionButton(wrapper, item))
                    .appendTo(container)
                    .on("click", async () => {
                        if (item.action && item.action.type == "Request") {
                            let container = await site.createContainer(item);
                            await container.start(item.action as IActionTypeRequest);
                        } else {
                            let action = SiteAction.create(wrapper, item.action);
                            action && action.execute();
                        }    
                    });
            }

            if (count > 0) {
                let listItem = QueryElement.QueryElement("LI")
                    .append(QueryElement.QueryElement("H2").setHtml(section.title))
                    .appendTo(list);

                if (section.sort == "small")
                    listItem.addClass("small");

                container.appendTo(listItem);
            }
        }
        this.append(list);

        this.addClass("start").on("click", async () => {
            
            if(this.containsClass("show")) {
                list.removeClass("in-grow")
                    .addClass("out-grow");

                if(!Site.isMobile())
                    await delay(200);
                
                this.removeClass("show");
            } else {
                this.addClass("show");
                list.removeClass("out-grow")
                    .addClass("in-grow");
            }
        });
        site.append(this);
    }

    makeActive() {
        this.addClass("active");
    }
    makeInactive() {
        this.removeClass("active");
    }
}

class SiteContainerStartWrapper
    implements ISiteContainer {

    private readonly _config: SiteConfig;

    on<TEvent extends Event>(val: string, func: (e: TEvent) => any) : (e: TEvent) => any {
        return () => {};
    }
    off<TEvent extends Event>(val: string, func: ((e: TEvent) => any) | null) : void {
        return;
    }

    get Config() { return { }; }
    get SiteConfig() { return this._config; }

    constructor(siteConfig: SiteConfig)
    {
        this._config = siteConfig;
    }
    redraw(): void {
        throw new Error("Method not implemented.");
    }
    back(): Promise<void> {
        throw new Error("Method not implemented.");
    }
    post(request: ISiteRequest): Promise<boolean> {
        throw new Error("Method not implemented.");
    }
    request(card: ISiteCard, request: ISiteRequest): Promise<boolean> {
        throw new Error("Method not implemented.");
    }
    appendCard(card: ISiteCard): Promise<void> {
        throw new Error("Method not implemented.");
    }
    makeCardActive(card: ISiteCard): Promise<void> {
        throw new Error("Method not implemented.");
    }
    replaceCard(oldCard: ISiteCard, newCard: ISiteCard): Promise<void> {
        throw new Error("Method not implemented.");
    }
    removeNextCards(card: ISiteCard): Promise<void> {
        return new Promise(() => { });
    }
    removeCard(card: ISiteCard): Promise<void> {
        return new Promise(() => { });
    }
    remove(removeInner?: boolean | undefined): Promise<void> {
        return new Promise(() => { });
    }
}